module.exports = __webpack_public_path__ + "media/images/default/lp_top_achieved_file3-84ca6385cb8ecdae213e070be4cf4cd6.svg";